import {
  validationCompany,
  addEscapeCharacter,
  validationNumeric,
} from '../lib/tools';
import config from '../config';
import * as types from '../lib/constants';

const appInitialState = {
  companies: [],
  openUpdateCompanyDialog: false,
  openCreateCompanyDialog: false,
  currentCompanyInfo: {},
  confirmData: {},
  confirmDataError: {
    companyCode: false,
    lat: false,
    lng: false,
    operatorDeviceLimit: false,
    downloadFileNamePatternId: false,
    storageLicense: {
      customNumber: false,
    },
    userLicense: {
      contractNumber: false,
    },
    voiceAnalysisLicense: {
      contractNumber: false,
    },
    ocrLicense: {
      contractNumber: false,
    },
    remoteSupportLicense: {
      contractNumber: false,
    },
  },
  refreshPage: false,
  selectedCompanyId: 0,
  selectedRoleId: 0,
  selectedStatus: config.accountStatus.ALL,
  selectedRemoteSupportStatus: types.REMOTE_SUPPORT_STATUS.all,
  searchOptions: {
    companyCode: '',
    companyName: '',
    companyTypes: [],
  },
  namePartial: '',
  companyTab: 1,
  licenseCapacityStatus: {
    ocrLicense: false,
    storageLicense: false,
    userLicense: false,
    voiceAnalysisLicense: false,
    remoteSupportLicense: false,
  },
  checkedLicenseOver: false,
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case 'SUCCESS_API_GET_COMPANIES': {
      const companies = action.payload.companies || [];

      // ライセンス超過状況を更新
      const licenseOverCompanies = companies.filter(
        c =>
          c.storageLicense.licenseCapacityStatus > 2 ||
          c.userLicense.licenseCapacityStatus > 2 ||
          c.remoteSupportLicense.licenseCapacityStatus > 2,
      );
      const storageLicense =
        companies.filter(c => c.storageLicense.licenseCapacityStatus > 2)
          .length > 0;
      const userLicense =
        companies.filter(c => c.userLicense.licenseCapacityStatus > 2).length >
        0;
      const ocrLicense =
        companies.filter(c => c.ocrLicense.licenseCapacityStatus > 2).length >
        0;
      const voiceAnalysisLicense =
        companies.filter(c => c.voiceAnalysisLicense.licenseCapacityStatus > 2)
          .length > 0;
      const remoteSupportLicense =
        companies.filter(
          c =>
            c.remoteSupportLicense &&
            c.remoteSupportLicense.licenseCapacityStatus > 2,
        ).length > 0;
      const licenseCapacityStatus = {
        ocrLicense,
        storageLicense,
        userLicense,
        voiceAnalysisLicense,
        remoteSupportLicense,
      };
      const checkedLicenseOver =
        state.checkedLicenseOver && licenseOverCompanies.length > 0;
      const displayCompanies =
        (checkedLicenseOver &&
          licenseOverCompanies.length > 0 &&
          licenseOverCompanies) ||
        companies;

      let currentCompanyInfo = { ...state.currentCompanyInfo };
      if (state.openUpdateCompanyDialog) {
        // 企業情報更新ダイアログ表示時は現在表示中の企業情報も設定
        const newCurrentCompanyInfo =
          companies &&
          companies.filter(c => c.companyId === currentCompanyInfo.companyId);
        if (newCurrentCompanyInfo.length === 1) {
          [currentCompanyInfo] = newCurrentCompanyInfo;
        }
      } else {
        currentCompanyInfo = companies && companies[0];
      }
      return {
        ...state,
        companies: displayCompanies,
        licenseCapacityStatus,
        checkedLicenseOver,
        currentCompanyInfo,
      };
    }
    case 'SUCCESS_API_UPDATE_COMPANIES': {
      const refreshPage = !state.refreshPage;
      return { ...state, refreshPage };
    }
    case 'UPDATE_CONFIRM_DATA': {
      const { updateParam } = action;
      const checkResult = validationCompany(updateParam);
      const confirmData = { ...state.confirmData, ...updateParam };
      const confirmDataError = { ...state.confirmDataError, ...checkResult };
      return { ...state, confirmData, confirmDataError };
    }
    case 'OPEN_UPDATE_COMPANY_DIALOG': {
      const openUpdateCompanyDialog = true;
      const id = action.id || null;
      const targetData =
        state.companies && state.companies.find(p => p.companyId === id);
      const companyId = (targetData && targetData.companyId) || null;
      const address = (targetData && targetData.address) || '';
      const lat = (targetData && targetData.lat) || null;
      const lng = (targetData && targetData.lng) || null;
      const operatorDeviceLimit =
        (targetData && targetData.operatorDeviceLimit) || null;
      const downloadFileNamePatternId =
        (targetData && targetData.downloadFileNamePatternId) || null;
      const zipCode = (targetData && targetData.zipCode) || '';
      const userLicense = (targetData && targetData.userLicense) || {};
      const voiceAnalysisLicense =
        (targetData && targetData.voiceAnalysisLicense) || {};
      const ocrLicense = (targetData && targetData.ocrLicense) || {};
      const storageLicense = (targetData && targetData.storageLicense) || {};
      const remoteSupportLicense =
        (targetData && targetData.remoteSupportLicense) || {};
      const confirmData =
        (targetData && {
          companyId,
          address,
          lat,
          lng,
          operatorDeviceLimit,
          downloadFileNamePatternId,
          zipCode,
          userLicense,
          voiceAnalysisLicense,
          ocrLicense,
          storageLicense,
          remoteSupportLicense,
        }) ||
        {};
      const currentCompanyInfo = { ...targetData };
      const checkTargets = [
        { lat: confirmData.lat || '' },
        { lng: confirmData.lng || '' },
      ];
      const checkResults = checkTargets.map(target =>
        validationCompany(target),
      );
      const errors = checkResults.reduce((previous, current) => {
        const result = { ...previous, ...current };
        return result;
      });
      const confirmDataError = { ...state.confirmDataError, ...errors };
      return {
        ...state,
        currentCompanyInfo,
        openUpdateCompanyDialog,
        confirmData: { ...confirmData },
        confirmDataError,
        companyTab: 1,
      };
    }
    case 'CLOSE_UPDATE_COMPANY_DIALOG': {
      const openUpdateCompanyDialog = false;
      const { confirmDataError, currentCompanyInfo } = appInitialState;
      return {
        ...state,
        openUpdateCompanyDialog,
        confirmDataError,
        currentCompanyInfo,
      };
    }
    case 'OPEN_CREATE_COMPANY_DIALOG': {
      const confirmData = {};
      const openCreateCompanyDialog = true;
      return { ...state, openCreateCompanyDialog, confirmData };
    }
    case 'CLOSE_CREATE_COMPANY_DIALOG': {
      const openCreateCompanyDialog = false;
      const { confirmData } = appInitialState;
      return { ...state, openCreateCompanyDialog, confirmData };
    }
    case 'SUCCESS_API_CREATE_COMPANY': {
      const openCreateCompanyDialog = false;
      const refreshPage = !state.refreshPage;
      const { searchOptions, checkedLicenseOver } = appInitialState;
      return {
        ...state,
        refreshPage,
        searchOptions,
        checkedLicenseOver,
        openCreateCompanyDialog,
      };
    }
    case 'ERROR_API_CREATE_COMPANY': {
      const errorCode = action.payload.errorCode || '';
      const confirmData = { ...state.confirmData, errorCode };
      return { ...state, confirmData };
    }
    case 'SELECT_COMPANY': {
      const selectedCompanyId =
        (action.companyId && Number(action.companyId)) || 0;
      const refreshPage = !state.refreshPage;
      return { ...state, selectedCompanyId, refreshPage };
    }
    case 'SET_GEOCODE_UPDATE_COMPANY_DIALOG': {
      const { updateParam } = action;
      const confirmData = { ...state.confirmData, ...updateParam };
      const confirmDataError = {
        ...state.confirmDataError,
        lat: false,
        lng: false,
      };
      return { ...state, confirmData, confirmDataError };
    }
    case 'SELECT_ROLE': {
      const selectedRoleId = (action.roleId && Number(action.roleId)) || 0;
      const refreshPage = !state.refreshPage;
      return { ...state, selectedRoleId, refreshPage };
    }
    case 'SEARCH_USER_NAME': {
      const namePartial = addEscapeCharacter(action.namePartial) || '';
      const refreshPage = !state.refreshPage;
      return { ...state, namePartial, refreshPage };
    }
    case 'UPDATE_COMPANY_SEARCH_OPTIONS': {
      const { options } = action;
      const searchOptions = {
        ...state.searchOptions,
        ...options,
      };
      return { ...state, searchOptions };
    }
    case 'UPDATE_COMPANY_SELECT_TAB': {
      const companyTab = action.tab;
      return { ...state, companyTab };
    }
    case 'RESET_COMPANY_SEARCH_OPTIONS': {
      const { checkedLicenseOver } = appInitialState;
      return {
        ...state,
        searchOptions: appInitialState.searchOptions,
        checkedLicenseOver,
      };
    }
    case 'UPDATE_LICENSE': {
      const { target, updateLicense } = action;
      switch (target) {
        case 'userLicense': {
          const newUserLicense = {
            ...state.confirmData[target],
            ...updateLicense,
          };
          const userLicense = {
            contractNumber: newUserLicense.contractNumber,
            usedNumber: newUserLicense.usedNumber,
          };
          const errors = {
            userLicense: {
              contractNumber: validationNumeric(newUserLicense.contractNumber),
            },
          };
          const confirmData = { ...state.confirmData, userLicense };
          const confirmDataError = { ...state.confirmDataError, ...errors };
          return { ...state, confirmData, confirmDataError };
        }
        case 'storageLicense': {
          const newStorageLicense = {
            ...state.confirmData[target],
            ...updateLicense,
          };
          const storageLicense = {
            storageType: newStorageLicense.storageType,
            customNumber: newStorageLicense.customNumber,
          };
          const errors = {
            storageLicense: {
              customNumber: validationNumeric(newStorageLicense.customNumber),
            },
          };
          const confirmData = { ...state.confirmData, storageLicense };
          const confirmDataError = { ...state.confirmDataError, ...errors };
          return { ...state, confirmData, confirmDataError };
        }
        case 'voiceAnalysisLicense': {
          const newVoiceAnalysisLicense = {
            ...state.confirmData[target],
            ...updateLicense,
          };
          const voiceAnalysisLicense = {
            enabled: newVoiceAnalysisLicense.enabled,
            autoAnalysisEnabled: newVoiceAnalysisLicense.autoAnalysisEnabled,
            contractNumber: newVoiceAnalysisLicense.contractNumber,
          };
          const errors = {
            voiceAnalysisLicense: {
              contractNumber: validationNumeric(
                newVoiceAnalysisLicense.contractNumber,
              ),
            },
          };
          const confirmData = { ...state.confirmData, voiceAnalysisLicense };
          const confirmDataError = { ...state.confirmDataError, ...errors };
          return { ...state, confirmData, confirmDataError };
        }
        case 'ocrLicense': {
          const newOcrLicense = {
            ...state.confirmData[target],
            ...updateLicense,
          };
          const ocrLicense = {
            enabled: newOcrLicense.enabled,
            autoAnalysisEnabled: newOcrLicense.autoAnalysisEnabled,
            contractNumber: newOcrLicense.contractNumber,
          };
          const errors = {
            ocrLicense: {
              contractNumber: validationNumeric(newOcrLicense.contractNumber),
            },
          };
          const confirmData = { ...state.confirmData, ocrLicense };
          const confirmDataError = { ...state.confirmDataError, ...errors };
          return { ...state, confirmData, confirmDataError };
        }
        case 'remoteSupportLicense': {
          const newRemoteSupportLicense = {
            ...state.confirmData[target],
            ...updateLicense,
          };
          const remoteSupportLicense = {
            enabled: newRemoteSupportLicense.enabled,
            contractNumber: newRemoteSupportLicense.contractNumber,
          };
          const errors = {
            remoteSupportLicense: {
              contractNumber: validationNumeric(
                newRemoteSupportLicense.contractNumber,
              ),
            },
          };
          const confirmData = { ...state.confirmData, remoteSupportLicense };
          const confirmDataError = { ...state.confirmDataError, ...errors };
          return { ...state, confirmData, confirmDataError };
        }
        default: {
          return { ...state };
        }
      }
    }
    case 'SELECT_STORAGE_PLAN': {
      const storagePlan = Number(action.plan);
      return { ...state, storagePlan };
    }
    case 'SELECT_ACCOUNT_STATUS': {
      const selectedStatus =
        action.status !== undefined
          ? Number(action.status)
          : appInitialState.selectedStatus;
      const refreshPage = !state.refreshPage;
      return { ...state, selectedStatus, refreshPage };
    }
    case 'CHECKED_LICENSE_OVER': {
      const checkedLicenseOver = action.checked;
      const refreshPage = !state.refreshPage;
      return { ...state, checkedLicenseOver, refreshPage };
    }
    case 'SELECT_REMOTE_SUPPORT_STATUS': {
      const selectedRemoteSupportStatus =
        action.status !== undefined
          ? Number(action.status)
          : appInitialState.selectedRemoteSupportStatus;
      const refreshPage = !state.refreshPage;
      return { ...state, selectedRemoteSupportStatus, refreshPage };
    }
    case 'OPEN_UPDATE_STAFF_DIALOG': {
      const companyCode = action.companyCode || '';
      const currentCompanyInfo =
        (state.companies &&
          state.companies.find(p => p.companyCode === companyCode)) ||
        {};
      return { ...state, currentCompanyInfo };
    }
    case 'CLOSE_UPDATE_STAFF_DIALOG': {
      const { currentCompanyInfo } = appInitialState;
      return { ...state, currentCompanyInfo };
    }
    default:
      return state;
  }
};
